import css from 'styled-jsx/css';
import { colors } from '../../config/styles';

export const ProductLandingContainerStyles = css`
  .pod-group {
    background-color: ${colors.gray.shade57};
  }
  .pod-group--container {
    display: flex;
    flex-direction: column;
    @mixin tabletToDesktop {
      flex-direction: row;
      padding-top: 15px;
    }
  }
  .pod-group--filters {
    width: 100%;
    background: ${colors.white.shade1};
    border-top: 0;
    border-bottom: 1px ${colors.gray.shade17} solid;
    border-radius: var(--border-radius);

    @mixin tabletToDesktop {
      border-bottom: 1px ${colors.gray.shade17} solid;
      border-radius: var(--border-radius);
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 20px;
      width: 26.2%;
      border: none;
    }
    @mixin desktop {
      min-width: 312px;
    }
  }
  .pod-group--products {
    width: 100%;
    margin-top: 10px;
    @mixin tabletToDesktop {
      width: calc(100% - 26.2%);
      display: flex;
      margin-top: 0;
      flex-direction: column;
    }
  }
  .filter-heading {
    padding: 20px 10px 10px 25px;
  }
  .pad-group--auto-correct {
    margin-bottom: 40px;
  }
  .pad-group--auto-correct-mkp {
    margin-bottom: 5px;
    @mixin mobileToTablet {
      margin-bottom: 23px;
    }
  }
  .pad-group--category-banner {
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
  }
  .total-results {
    padding: 8px 0;
  }
  .survey-container {
    display: none;
    @mixin tabletToDesktop {
      display: flex;
    }
  }

  .survey-container-mobile {
    display: flex;
    margin-bottom: 5px;
    @mixin tabletToDesktop {
      display: none;
    }
  }

  .google-ad-top {
    text-align: center;
  }
  .google-ad-side {
    width: 300px;
    position: sticky;
    align-self: center;
    top: 0;
  }
`;
